// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"396":"7d607a8c","902":"3cc17f08"}[chunkId] + ".chunk.css";
};